import { Property, PropertyType } from '../../../../base/types';

import { IProperty } from '../../../../base/models';

export const PaymentButtonProperties: IProperty[] = [
    { id: Property.EnableOnline, name: 'Enable Online', type: PropertyType.Boolean },
    { id: Property.EnableOffline, name: 'Enable Offline', type: PropertyType.Boolean },
    { id: Property.EnableDeferment, name: 'Enable Deferment', type: PropertyType.Boolean },
    { id: Property.EnableRazorPay, name: 'Enable RazorPay', type: PropertyType.Boolean },
    { id: Property.EnablePayU, name: 'Enable PayU', type: PropertyType.Boolean },
    { id: Property.EnablePaytm, name: 'Enable Paytm', type: PropertyType.Boolean },
    { id: Property.EnableFlywire, name: 'Enable Flywire', type: PropertyType.Boolean },
    { id: Property.EnableNTT, name: 'Enable NTT', type: PropertyType.Boolean },
    { id: Property.EnableHDFC, name: 'Enable HDFC', type: PropertyType.Boolean },
    { id: Property.EnableAMBANK, name: 'Enable AM Bank', type: PropertyType.Boolean },
    { id: Property.TableLookup, name: 'Table Lookup', type: PropertyType.TableLookup },
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.OrderNo, name: 'Order No.', type: PropertyType.String },
    { id: Property.EnrolmentNo, name: 'Enrolment No.', type: PropertyType.String },
    { id: Property.Amount, name: 'Amount', type: PropertyType.Number },
    { id: Property.Currency, name: 'Currency', type: PropertyType.String },
    { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Disabled, name: 'Disabled', type: PropertyType.Boolean },
    { id: Property.BackgroundStyle, name: 'Style', type: PropertyType.ButtonStyle },
    { id: Property.Size, name: 'Size', type: PropertyType.ControlSize },
    { id: Property.SuccessPage, name: 'Success Page', type: PropertyType.PageLink },
    { id: Property.FailedPage, name: 'Failed Page', type: PropertyType.PageLink },
    { id: Property.Entity, name: 'Entity', type: PropertyType.Entity },
    { id: Property.EntityId, name: 'EntityId', type: PropertyType.String },
    { id: Property.TutionFee, name: 'TutionFee', type: PropertyType.Number },
    { id: Property.HostelFee, name: 'HostelFee', type: PropertyType.Number },
    { id: Property.OtherFee, name: 'OtherFee', type: PropertyType.Number },
    { id: Property.RelativePath, name: 'Relative Path', type: PropertyType.String },
    { id: Property.TableSchema, name: 'Table Schema', type: PropertyType.String },
    { id: Property.AmountSchema, name: 'Amount Schema', type: PropertyType.String },
    { id: Property.DateSchema, name: 'Date Schema', type: PropertyType.String },
    { id: Property.ReferenceSchema, name: 'Reference Schema', type: PropertyType.String },
    { id: Property.RemarkSchema, name: 'Remark Schema', type: PropertyType.String },
]
